import CONST from './const'

class Painter {
    canvas = null;
    context = null;
    paint_color = '#6EE1B9';

    is_drawing = false;
    undo_stack = [];
    redo_stack = [];
    save_undo_stack = null;
    save_redo_stack = null;
    temp_image_data = null;
    save_image_data = null;
    begin_point = [0, 0];
    stack_size = 10;

    paint_mode = CONST.PAINT_MODE_BRUSH;
    paint_type = CONST.PAINT_FREE_HAND;

    brush_size = 10;

    constructor(canvas, config) {
        if (!canvas) throw Error('canvas is required in painter');
        this.canvas = canvas;
        this.context = canvas.getContext('2d');
        this.updateConfig(config);
        this.invert();
        this.pushHistory();
    }

    updateConfig(config_obj) {
        const property_filter = ['paint_mode', 'paint_type', 'brush_size'];

        const valid_configs = property_filter.reduce( (accumulator, item) => {
            return (config_obj[item])
                ? {[item]: config_obj[item], ...accumulator}
                : accumulator;
        }, {});

        Object.assign(this, valid_configs);
    }

    //クリッピング画像読み込み
    setImage(img_el) {
        this.clearHistory();
        this.invert();
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.drawImage(img_el, 0, 0, this.canvas.width, this.canvas.height);
        this.pushHistory();
    }

    //セーブ＆リストア
    save() {
        this.save_undo_stack = [...this.undo_stack];
        this.save_redo_stack = [...this.redo_stack];
        this.save_image_data = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
    restore() {
        if ( !(this.save_undo_stack && this.save_redo_stack && this.save_image_data) ) return;
        this.undo_stack = this.save_undo_stack;
        this.redo_stack = this.save_redo_stack;
        this.context.putImageData(this.save_image_data, 0, 0);
    }

    //履歴管理系
    pushHistory() {
        if (this.canvas.width === 0 || this.canvas.height === 0) { return; } //width、heightが0だとgetImageDataが動かない
        this.redo_stack.length = 0;
        const snapshot = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        this.undo_stack.push( snapshot );
        if ( this.undo_stack.length > this.stack_size + 1 ) this.undo_stack.shift();
    }
    undo() {
        if ( this.undo_stack.length <= 1 ) return;
        this.redo_stack.push( this.undo_stack.pop() );
        const undo_snapshot = this.undo_stack[this.undo_stack.length - 1];
        this.context.putImageData(undo_snapshot, 0, 0);
    }
    redo() {
        if ( !this.redo_stack.length ) return;
        const redo_snapshot = this.redo_stack.pop();
        this.undo_stack.push( redo_snapshot );
        this.context.putImageData(redo_snapshot, 0, 0);
    }
    clearHistory() {
        this.redo_stack.length = 0;
        this.undo_stack.length = 0;
    }

    //描画系
    drawStart(x, y) {
        if (this.is_drawing) this.drawEnd();
        this.is_drawing = true;

        this.context.strokeStyle = this.paint_color;
        this.context.fillStyle = this.paint_color;

        this.context.globalCompositeOperation = this.paint_mode === CONST.PAINT_MODE_BRUSH ? 'destination-out' : 'source-over';
        this.context.lineWidth = this.brush_size;

        switch (this.paint_type) {
            case CONST.PAINT_FREE_HAND: {
                this.startFreehand(x, y);
                break;
            }
            case CONST.PAINT_DRAW_LINE: {
                this.startLine(x, y);
                break;
            }
            case CONST.PAINT_DRAW_SQUARE: {
                this.startSquare(x, y);
                break;
            }
        }
    }
    draw(x, y) {
        if (!this.is_drawing) return;

        switch (this.paint_type) {
            case CONST.PAINT_FREE_HAND: {
                this.drawFreehand(x, y);
                break;
            }
            case CONST.PAINT_DRAW_LINE: {
                this.drawLine(x, y);
                break;
            }
            case CONST.PAINT_DRAW_SQUARE: {
                this.drawSquare(x, y);
                break;
            }
        }
    }
    drawEnd(x, y) {
        this.is_drawing = false;

        switch (this.paint_type) {
            case CONST.PAINT_FREE_HAND: {
                this.endFreehand(x, y);
                break;
            }
            case CONST.PAINT_DRAW_LINE: {
                this.endLine(x, y);
                break;
            }
            case CONST.PAINT_DRAW_SQUARE: {
                this.endSquare(x, y);
                break;
            }
        }

        this.pushHistory();
    }
    clear() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.invert();
        this.pushHistory();
    }

    invert() {
        this.context.strokeStyle = this.paint_color;
        this.context.fillStyle = this.paint_color;
        this.context.globalCompositeOperation = 'xor';
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.globalCompositeOperation = 'source-over';
    }

    //ペイントモード：フリーハンド
    startFreehand(x, y) {
        this.context.lineCap = 'round';
        this.context.lineJoin = 'round';
        this.context.beginPath();
        this.context.moveTo(x, y);
    }
    drawFreehand(x, y) {
        this.context.lineTo(x, y);
        this.context.stroke();
    }
    endFreehand(x, y) {
        this.draw(x, y);
    }

    //ペイントモード：直線
    startLine(x, y) {
        this.begin_point = [x, y];
        this.temp_image_data = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
    drawLine(x, y) {
        if ( !this.temp_image_data ) this.startLine(x, y);
        this.context.lineCap = 'butt';
        this.context.lineJoin = 'bevel';
        this.context.putImageData(this.temp_image_data, 0, 0);
        this.context.beginPath();
        this.context.moveTo(...this.begin_point);
        this.context.lineTo(x, y);
        this.context.stroke();
    }
    endLine(x, y) {
        this.drawLine(x, y);
        this.begin_point = [0, 0];
        this.temp_image_data = null;
    }

    //ペイントモード：矩形
    startSquare(x, y) {
        this.begin_point = [x, y];
        this.temp_image_data = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
    }
    drawSquare(x, y) {
        if ( !this.temp_image_data ) this.startSquare(x, y);
        this.context.putImageData(this.temp_image_data, 0, 0);
        this.context.beginPath();
        const [sx, sy] = this.begin_point;
        this.context.rect(sx, sy, x - sx, y - sy);
        this.context.fill();
    }
    endSquare(x, y) {
        this.drawSquare(x, y);
        this.begin_point = [0, 0];
        this.temp_image_data = null;
    }

    //アウトプット系
    getImage() {
        return new Promise(resolve => {
            this.invert();
            const img = new Image();
            img.onload = () => {
                this.invert();
                resolve(img);
            };
            img.src = this.canvas.toDataURL();
        })
    }
    getCanvas() {
        return this.canvas;
    }
}

export default Painter;
